import { Card, Table } from "antd";
import { useEffect, useState } from "react";
import { UserMissions } from "../../RestAPI/dbo/Missionsapi";

function Missions() {

    
    const columns = [
        {
            title: 'کد',
            dataIndex: 'ID',
            key: 'ID',
        },
        {
            title: 'نوع',
            dataIndex: 'Type',
            key: 'Type',
        },
        {
            title: 'وضعیت',
            dataIndex: 'Status',
            key: 'Status',
        },
        {
            title: 'مشتری',
            dataIndex: 'Customer',
            key: 'Customer',
        },
        {
            title: 'تاریخ',
            dataIndex: 'PDate',
            key: 'PDate',
        },
        {
            title: 'مدل دستگاه',
            dataIndex: 'MachineModel',
            key: 'MachineModel',
        },
        {
            title: 'سریال دستگاه',
            dataIndex: 'Serial',
            key: 'Serial',
        },
        {
            title: 'توضیحات',
            dataIndex: 'Description',
            key: 'Description',
        }
    ];

    const[list,setList]=useState<Array<{}>>([]);

    async function fetchData() {
        const list = await UserMissions();
        setList(list);
      }
      useEffect(() => {
        fetchData();
      }, []);
    

    return (
        <>
            <Card
                title="سوابق ماموریت"
                style={{ margin: 10 }}
            >
                <Table
                     pagination={{ pageSize: 20}}
                    dataSource={list}
                    columns={columns}
                    scroll={{ x: 'max-content',y:"calc(100vh - 220px)"  }}
                    showHeader={true}
                    />


            </Card>
        </>
    );
}

export default Missions;